
import { useTranslation } from 'react-i18next';
import { SubscriptionManagement } from '@/components/subscriptions/subscription-management';

export default function BillingPage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">{t('billing.title')}</h1>
        <p className="text-muted-foreground">{t('billing.description')}</p>
      </div>

      <SubscriptionManagement />
    </div>
  );
}
